/* istanbul ignore file */ // TODO Byro add unit tests once confirmed this isn't in need of new design
import { getPaletteColor } from 'pcln-design-system';
import React, { useCallback, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { usePennySubscriber, BroadcastType } from '../utils/pennyBroadcast';
import StopIcon from '../svgs/StopIcon';
const CIRCLE_OPACITY = 0.3;
const ROTATION_DURATION = 5; // How long it takes for the entire circle container to rotate 360 degrees
const TRAVEL_DURATION = 5; // How long it takes for the circle to travel in a complete triangle
const CIRCLE_TRAVEL_DURATION = 6; // Circle Travel Distance in pixels from origin to points of triangles
// const StyledCanvas = styled('canvas')`
//   position: fixed;
//   margin-top: 15px;
// `
const CircleContainer = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__CircleContainer",
  componentId: "sc-pudppe-0"
})(["position:relative;transform-origin:", ";top:-80px;left:-80px;"], props => `${props.originX}px ${props.originY}px`);
const actionTextVariants = {
  open: {
    opacity: 1,
    translateY: 6,
    transition: {
      duration: 0.3
    }
  },
  closed: {
    opacity: 0,
    translateY: 135,
    transition: {
      duration: 0.3
    }
  }
};
const ActionText = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__ActionText",
  componentId: "sc-pudppe-1"
})(["font-size:16px;display:flex;align-items:center;font-weight:700;line-height:20px;z-index:1000;color:", ";opacity:0;svg{margin-right:6px;}"], props => `${getPaletteColor('text.lightest')(props)}`);
const Overlay = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__Overlay",
  componentId: "sc-pudppe-2"
})(["bottom:0;cursor:pointer;right:0;display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:1000;background:linear-gradient(135deg,#9654cd 40%,#6f78e5 80%);"]);
const Circle = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__Circle",
  componentId: "sc-pudppe-3"
})(["border-radius:50%;position:absolute;background:", ";width:", ";height:", ";"], props => props.color || 'transparent', props => props.width, props => props.height);
const RecordingIndicator = ({
  isRecording,
  onClose,
  height,
  originX = 80,
  originY = 80,
  rotationDuration = ROTATION_DURATION,
  travelDuration = TRAVEL_DURATION,
  circleTravelDistance = CIRCLE_TRAVEL_DURATION,
  circleOpacity = CIRCLE_OPACITY,
  circleHeight,
  circleWidth
}) => {
  const circleTransition = {
    type: 'spring',
    bounce: 1,
    duration: travelDuration,
    repeat: Infinity
  };
  const overlayVariants = {
    open: {
      borderRadius: '0px',
      height,
      bounce: 0,
      transition: {
        ease: [0.25, 0.1, 0.25, 1.0]
      },
      originX: 1,
      originY: 0,
      opacity: 0.98
    },
    closed: {
      borderRadius: '0%',
      transition: {
        ease: [0.25, 0.1, 0.25, 1.0]
      },
      height: '0px',
      originX: 1,
      originY: 0,
      opacity: 0
    }
  };
  const circleContainerVariants = {
    open: {
      rotate: 360,
      transition: {
        repeat: Infinity,
        duration: rotationDuration,
        ease: 'linear'
      }
    }
  };
  const [showOverlay, setShowOverlay] = useState(isRecording);
  const pennyBroadcastListener = useCallback(event => {
    if (event.data.type === BroadcastType.VOICE_RECORDING_STARTED) {
      setShowOverlay(true);
    } else if (event.data.type === BroadcastType.VOICE_RECORDING_STOPPED) {
      setShowOverlay(false);
    }
  }, []);
  usePennySubscriber(pennyBroadcastListener);
  useEffect(() => {
    setShowOverlay(isRecording);
  }, [isRecording]);
  return React.createElement(React.Fragment, null, React.createElement(Overlay, {
    animate: showOverlay ? 'open' : 'closed',
    initial: {
      height: 0,
      overflow: 'hidden'
    },
    variants: overlayVariants,
    onClick: onClose
  }, React.createElement(ActionText, {
    animate: showOverlay ? 'open' : 'closed',
    variants: actionTextVariants
  }, React.createElement(StopIcon, null), "Finish speaking to send"), React.createElement(CircleContainer, {
    originx: originX,
    originy: originY,
    animate: showOverlay ? 'open' : 'closed',
    variants: circleContainerVariants
  }, React.createElement(Circle, {
    key: 'animated-circle-1',
    initial: {
      y: -circleTravelDistance,
      opacity: circleOpacity
    },
    animate: {
      x: [0, circleTravelDistance, -circleTravelDistance, 0],
      y: [-circleTravelDistance, circleTravelDistance, circleTravelDistance, -circleTravelDistance]
    },
    transition: circleTransition,
    height: circleHeight,
    width: circleWidth,
    color: '#7701BB'
  }), React.createElement(Circle, {
    key: 'animated-circle-2',
    initial: {
      y: circleTravelDistance,
      x: circleTravelDistance,
      opacity: circleOpacity
    },
    animate: {
      x: [circleTravelDistance, -circleTravelDistance, 0, circleTravelDistance],
      y: [circleTravelDistance, circleTravelDistance, -circleTravelDistance, circleTravelDistance]
    },
    transition: circleTransition,
    height: circleHeight,
    width: circleWidth,
    color: '#BB01B4'
  }), React.createElement(Circle, {
    key: 'animated-circle-3',
    initial: {
      x: -circleTravelDistance,
      y: circleTravelDistance,
      opacity: circleOpacity
    },
    animate: {
      x: [-circleTravelDistance, 0, circleTravelDistance, -circleTravelDistance],
      y: [circleTravelDistance, -circleTravelDistance, circleTravelDistance, circleTravelDistance]
    },
    transition: circleTransition,
    height: circleHeight,
    width: circleWidth,
    color: '#0068EF'
  }))));
};
export default RecordingIndicator;